import { useState } from "react";
import { Button } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconFilter2 } from "@tabler/icons-react";
import DataTablePortal from "./components/DataTablePortal";
import { TableHeaderTypeBase, FilterCondition, TablePortals } from "./types";
import FiltersSection from "./FiltersSection";
import useActiveFilters from "./hooks/useActiveFilters";
import { FilterApplicableFor, SavedFilter } from "../tags/types";
import ClearFilters from "../tags/ClearFilters";
import SavedFilters from "../tags/SavedFilters";

interface AddFiltersButtonProps {
  portals?: TablePortals;
  headers?: TableHeaderTypeBase[];
  onFiltersChange?: (filters: FilterCondition[]) => void;
  applicableFor?: FilterApplicableFor;
  clearFiltersKeysToPreserve?: string[];
}

const AddFiltersButton = ({
  portals,
  headers,
  onFiltersChange,
  applicableFor,
  clearFiltersKeysToPreserve,
}: AddFiltersButtonProps) => {
  const [showFilters, setShowFilters] = useState(false);
  const [editFilter, setEditFilter] = useState<SavedFilter | undefined>();
  const { activeFiltersCount } = useActiveFilters(headers);

  const handleFiltersChange = (filters: FilterCondition[]) => {
    onFiltersChange?.(filters);
  };

  const handleEditFilter = (filter: SavedFilter) => {
    setEditFilter(filter);
    setShowFilters(true);
  };

  return (
    <>
      {portals?.filter && applicableFor ? (
        <DataTablePortal id={portals.filter}>
          <Stack align="center" gap="sm">
            <Button variant="outline" onClick={() => setShowFilters(true)}>
              <Stack align="center" gap="sm">
                <IconFilter2 size={16} />
                More Filters
                {activeFiltersCount > 0 && (
                  <span className="al-bg-red-500 al-text-white al-text-xs al-rounded-full al-px-2 al-py-[3px] al-min-w-[20px] al-h-5">
                    {activeFiltersCount}
                  </span>
                )}
              </Stack>
            </Button>
            {activeFiltersCount > 0 && <ClearFilters keysToPreserve={clearFiltersKeysToPreserve} />}
          </Stack>
        </DataTablePortal>
      ) : null}
      {portals?.savedFilters && applicableFor && (
        <DataTablePortal id={portals.savedFilters}>
          <SavedFilters
            applicableFor={applicableFor}
            onEdit={handleEditFilter}
            headers={headers}
            buttonProps={{ variant: "outline" }}
            enableNewUi
          />
        </DataTablePortal>
      )}
      <FiltersSection
        headers={headers || []}
        onFiltersChange={handleFiltersChange}
        onClose={() => {
          setShowFilters(false);
          setEditFilter(undefined);
        }}
        open={showFilters}
        applicableFor={applicableFor}
        editFilter={editFilter}
      />
    </>
  );
};

export default AddFiltersButton;
